import React from "react";
import { Button, Tooltip } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { GESTION_ROUTES } from "constants/gestion-routes";
import { useGestionShellCompetition } from "hooks/useGestionShellCompetition";
import { useGestionAccess } from "hooks/useGestionAccess";

// "Crear torneo" that follows the backend's tournament_creation permission (X-03):
// disabled with the backend's reason when the organization can't create tournaments.
// Not rendered at all without the Torneos area (finance-only administrators): the backend answers 403 anyway.
const CreateTournamentButton = ({ customerId, children, ...buttonProps }) => {
  const { tournamentCreation } = useGestionShellCompetition();
  const { can } = useGestionAccess({ customerId });
  if (!can("tournaments")) return null;
  const blocked = tournamentCreation?.allowed === false;

  const button = (
    <Button
      data-testid="create-tournament"
      component={blocked ? "button" : RouterLink}
      to={blocked ? undefined : GESTION_ROUTES.tournamentsCreate(customerId)}
      disabled={blocked}
      {...buttonProps}
    >
      {children}
    </Button>
  );

  if (!blocked) return button;
  return (
    <Tooltip title={tournamentCreation.message || ""}>
      <span>{button}</span>
    </Tooltip>
  );
};

export default CreateTournamentButton;
